/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

class LiveCurrentTitle extends Component {
  state = {
    currentData: this.props.childProps.currentData,
  };
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
    //this._getCurrentTitle()
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  /*
    _getCurrentTitle = async () => {
        const result = await this._getCurrentTitleApi();

        const intReturn = result.data[0].intReturn;
        const currentData = result.data[0].listData;

        if(intReturn === 0) {
            if(this._isMounted) {
                this.setState({
                    currentData
                })
            }
        }
    }
    _getCurrentTitleApi = () => {
        const { apiUrl } = this.props;

        return axios(apiUrl + '/liveCurrentTitle')
        .then(response => response)
        .catch(error => {
            //console.log('error...')
        })
    }
    */
  render() {
    const { currentData } = this.state;
    return (
      <Fragment>
        {currentData ? (
          /*PV 및 광고 재생중에는 타이틀 이미지 및 제목 안나오게끔*/
          parseInt(currentData[0].curSecond) >
          parseInt(currentData[0].startSecond) ? (
            <Fragment>
              <h1>
                {currentData[0].imageOL === null ||
                currentData[0].imageOL === undefined ||
                currentData[0].imageOL === "" ? (
                  <div
                    style={{
                      fontSize: 26,
                      fontWeight: "800",
                      color: "#ffffff",
                    }}
                  >
                    {currentData[0].title}
                  </div>
                ) : (
                  <img
                    src={currentData[0].imageOL}
                    style={{ width: "30%", height: "30%" }}
                  />
                )}
              </h1>
              <h3 style={{ paddingTop: 30 }}>{currentData[0].subTitle}</h3>
              <div>
                <div style={{ width: "0%" }}></div>
                {/*<span style={{left: '0%'}}></span>*/}
              </div>
            </Fragment>
          ) : null
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(LiveCurrentTitle));
